import { Controller } from '@hotwired/stimulus'
import Toast from '/libs/toast'

export default class extends Controller {
  // Streamed modals are appended to the body, so they leave the DOM when closed.
  static values = { transient: Boolean }

  open() {
    this._toggle(true)
  }

  close(event) {
    const response = event.detail?.fetchResponse?.response

    if (event.type == 'turbo:submit-end') {
      const headers = response.headers
      if (headers.get('x-message'))
        new Toast(decodeURIComponent(escape(headers.get('x-message'))), { type: headers.get('x-message-type') }).show()

      if (!event.detail.success) return
      // Turbo pushes the history entry itself, same as the dialog stream action
      else if (headers.get('redirect-to')) Turbo.visit(headers.get('redirect-to'))
    }

    if (response?.status != 206) // Do not close on Partial Content
      this._toggle(false)
  }

  _toggle(state) {
    this.element.toggleAttribute('hidden', !state)
    if (!state && this.transientValue) this.element.remove()

    // Main scroll lock. A modal can be stacked over another one, so closing one only unlocks the
    // page once none is left open — hence the query, after this one is hidden or gone.
    document.body.classList.toggle('modal-is-open', state || !!document.querySelector('.modal-slot:not([hidden])'))
  }
}
